// The tooltip look of the ported ionq-cloud-ui pages (dark bubble, arrow,
// body-6 text, no open delay) as a preset over the shared legacy-ui
// Tooltip.

import { Icon, Text } from '@chakra-ui/react';
import { Tooltip as LegacyTooltip } from '@ionq/legacy-ui';
import React from 'react';
import { MdHelpOutline } from 'react-icons/md';

export const Tooltip = ({
    content,
    children,
}: {
    content: React.ReactNode;
    children?: React.ReactNode;
}) => {
    // The trigger must be a single element (asChild): wrap plain text and
    // fragments; no children at all renders the help glyph.
    const trigger = React.isValidElement(children) ? (
        children
    ) : (
        <span>
            {children ?? (
                <Icon
                    as={MdHelpOutline}
                    boxSize='14px'
                    ml='4px'
                    mb='-2px'
                    cursor='pointer'
                    color='fg.subtle'
                />
            )}
        </span>
    );
    return (
        <LegacyTooltip
            openDelay={0}
            closeDelay={0}
            showArrow
            content={<Text textStyle='body-6'>{content}</Text>}
            contentProps={{
                // The bubble color rides the recipe's --tooltip-bg variable
                // (bg + arrow + arrow border all derive from it) — setting
                // `bg` directly would repaint the bubble and leave the arrow
                // on the default color. fg/bg inverts per mode: dark bubble
                // with light text in light mode, and vice versa.
                css: { '--tooltip-bg': 'colors.fg' },
                borderRadius: '5px',
                color: 'bg',
                ml: ['5px', '3px'],
                overflowWrap: 'break-word',
                maxW: ['280px'],
                p: '2px 8px',
            }}
        >
            {trigger}
        </LegacyTooltip>
    );
};
